import React, { useState, ChangeEvent, FormEvent } from "react";
import { Grid, TextField, Button } from "@mui/material";
import SimpleReactValidator from "simple-react-validator";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

interface CardForm {
  email: string;
  password: string;
  card_holder: string;
  card_number: string;
  cvv: string;
  expire_date: string;
  remember: boolean;
}

const CheckWrap: React.FC = () => {
  const navigate = useNavigate();

  const [value, setValue] = useState<CardForm>({
    email: "user@gmail.com",
    password: "123456",
    card_holder: "Jhon Doe",
    card_number: "589622144",
    cvv: "856226",
    expire_date: "",
    remember: false,
  });

  const [validator] = useState(
    new SimpleReactValidator({
      className: "errorMessage",
    })
  );

  // ✅ Handle Input Changes (typed)
  const changeHandler = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ): void => {
    const { name, value: inputValue } = e.target;
    setValue((prev) => ({ ...prev, [name]: inputValue }));
    validator.showMessages();
  };

  // ✅ Handle Submit (typed)
  const submitForm = (e: FormEvent<HTMLFormElement>): void => {
    e.preventDefault();

    if (validator.allValid()) {
      validator.hideMessages();

      const userRegex = /^user+.*/gm;
      const email = value.email;

      if (email.match(userRegex)) {
        toast.success("Order received successfully!");
        navigate("/order_received");
      } else {
        toast.info("User not found!");
        alert(
          "User not found! Try one of these credentials:\nuser@*****.com | vendor@*****.com | admin@*****.com"
        );
      }

      // Reset form after submission
      setValue({
        email: "",
        password: "",
        card_holder: "",
        card_number: "",
        cvv: "",
        expire_date: "",
        remember: false,
      });
    } else {
      validator.showMessages();
      toast.error("Empty field is not allowed!");
    }
  };

  return (
    <Grid className="cardbp mt-20">
      <Grid>
        <form onSubmit={submitForm}>
          <Grid container spacing={3}>
            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label="Card Holder Name"
                name="card_holder"
                value={value.card_holder}
                onChange={changeHandler}
                type="text"
                InputLabelProps={{ shrink: true }}
                className="formInput radiusNone"
              />
              {validator.message("card_holder", value.card_holder, "required")}
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label="Card Number"
                name="card_number"
                value={value.card_number}
                onChange={changeHandler}
                type="number"
                InputLabelProps={{ shrink: true }}
                className="formInput radiusNone"
              />
              {validator.message("card_number", value.card_number, "required|numeric")}
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label="CVV"
                name="cvv"
                value={value.cvv}
                onChange={changeHandler}
                type="text"
                InputLabelProps={{ shrink: true }}
                className="formInput radiusNone"
              />
              {validator.message("cvv", value.cvv, "required|numeric")}
            </Grid>

            <Grid item sm={6} xs={12}>
              <TextField
                fullWidth
                label="Expire Date"
                name="expire_date"
                value={value.expire_date}
                onChange={changeHandler}
                type="date"
                InputLabelProps={{ shrink: true }}
                className="formInput radiusNone"
              />
              {validator.message("expire_date", value.expire_date, "required")}
            </Grid>

            <Grid item xs={12}>
              <Grid className="formFooter mt-20">
                <Button
                  fullWidth
                  className="cBtn cBtnLarge cBtnTheme mt-20 ml-15"
                  type="submit"
                >
                  Proceed to Checkout
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </form>
      </Grid>
    </Grid>
  );
};

export default CheckWrap;
